export const TOAST_ERROR_CONSTS = {
    errorMsg: 'Ошибка',
    hideMsg: 'Скрыть',
    moreInfoMsg: 'Подробнее',
    retryMsg: 'Повторить'
}
